module.exports = __webpack_public_path__ + "static/desktop_34-594d2021dfc9de8ec50b26646b4a7878.jpg";